import { portalText, usePortalTranslation } from "../../../i18n/portal.js";
/**
 * The deferred tab state.
 *
 * Seven of the Agent screen's nine tabs are built by later units. They still have to exist,
 * because the tab strip is part of the design and hiding a tab would misrepresent the
 * product — so each renders this, which says three true things: what the tab will hold, that
 * it is not built yet, and which unit builds it.
 *
 * This state is **registered in `docs/design/screen-manifest.json`** against the `Agent` row
 * (`tab-deferred`, plus the per-tab states). `tools/screen-coverage` fails CI on a gap it
 * has not been told about, and an unregistered blank tab is precisely such a gap.
 */
import { Icon, Tag } from "@wetalk/ui";
import type { ReactNode } from "react";

import type { VoiceAgentTabDefinition } from "./agent-tabs.js";

export function DeferredTab({ tab }: { readonly tab: VoiceAgentTabDefinition }): ReactNode {
  usePortalTranslation("operations");
  return (
    <div className="c-deferred" role="status">
      <Icon glyph={tab.glyph} size="3xl" tone="muted" />
      <p className="c-deferred-title">{tab.label}</p>
      <p className="c-deferred-dek">{tab.promise}</p>
      <Tag tone="outline">{portalText("operations", "not_built_yet_3c94c214")}{tab.phase}</Tag>
    </div>
  );
}
